import { dateTimeToString } from "../../../shared/utils/Dates";
import { ChatShort } from "../../../shared/models/Chat";

interface ChatInfoProps {
  chat: ChatShort;
}

export default function ChatInfo({ chat }: ChatInfoProps) {
  if (!chat || !chat.startedAt) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center">
        <span className="text-base font-medium">
          Date: {dateTimeToString(chat.startedAt)}
        </span>
      </div>
    </div>
  );
}
